import { isCorporateOnlyAccount } from '@packages/core/auth';

/**
 * Whether the account may edit a draft Techline case: corporate-only users
 * cannot; everyone else can.
 *
 * @param baseRoleIds - The account's base role IDs.
 * @returns true when the account may edit draft cases.
 */
export function canEditDraftForRoles(baseRoleIds: readonly string[] | undefined): boolean {
    return !isCorporateOnlyAccount(baseRoleIds);
}
